/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WizardPlanTaskDto } from './WizardPlanTaskDto';
import {
    WizardPlanTaskDtoFromJSON,
    WizardPlanTaskDtoFromJSONTyped,
    WizardPlanTaskDtoToJSON,
    WizardPlanTaskDtoToJSONTyped,
} from './WizardPlanTaskDto';
import type { WizardPlanAssignmentDto } from './WizardPlanAssignmentDto';
import {
    WizardPlanAssignmentDtoFromJSON,
    WizardPlanAssignmentDtoFromJSONTyped,
    WizardPlanAssignmentDtoToJSON,
    WizardPlanAssignmentDtoToJSONTyped,
} from './WizardPlanAssignmentDto';

/**
 * 
 * @export
 * @interface CreatePlanFromWizardRequestDto
 */
export interface CreatePlanFromWizardRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanFromWizardRequestDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanFromWizardRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanFromWizardRequestDto
     */
    priority?: CreatePlanFromWizardRequestDtoPriorityEnum;
    /**
     * Days ahead of due date when ticket generation may create a Preventive Ticket (default 90)
     * @type {number}
     * @memberof CreatePlanFromWizardRequestDto
     */
    schedulingHorizonDays?: number;
    /**
     * 
     * @type {Array<WizardPlanTaskDto>}
     * @memberof CreatePlanFromWizardRequestDto
     */
    tasks: Array<WizardPlanTaskDto>;
    /**
     * 
     * @type {WizardPlanAssignmentDto}
     * @memberof CreatePlanFromWizardRequestDto
     */
    assign?: WizardPlanAssignmentDto;
}


/**
 * @export
 */
export const CreatePlanFromWizardRequestDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type CreatePlanFromWizardRequestDtoPriorityEnum = typeof CreatePlanFromWizardRequestDtoPriorityEnum[keyof typeof CreatePlanFromWizardRequestDtoPriorityEnum];


/**
 * Check if a given object implements the CreatePlanFromWizardRequestDto interface.
 */
export function instanceOfCreatePlanFromWizardRequestDto(value: object): value is CreatePlanFromWizardRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tasks' in value) || value['tasks'] === undefined) return false;
    return true;
}

export function CreatePlanFromWizardRequestDtoFromJSON(json: any): CreatePlanFromWizardRequestDto {
    return CreatePlanFromWizardRequestDtoFromJSONTyped(json, false);
}

export function CreatePlanFromWizardRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanFromWizardRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'schedulingHorizonDays': json['schedulingHorizonDays'] == null ? undefined : json['schedulingHorizonDays'],
        'tasks': ((json['tasks'] as Array<any>).map(WizardPlanTaskDtoFromJSON)),
        'assign': json['assign'] == null ? undefined : WizardPlanAssignmentDtoFromJSON(json['assign']),
    };
}

export function CreatePlanFromWizardRequestDtoToJSON(json: any): CreatePlanFromWizardRequestDto {
    return CreatePlanFromWizardRequestDtoToJSONTyped(json, false);
}

export function CreatePlanFromWizardRequestDtoToJSONTyped(value?: CreatePlanFromWizardRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'priority': value['priority'],
        'schedulingHorizonDays': value['schedulingHorizonDays'],
        'tasks': ((value['tasks'] as Array<any>).map(WizardPlanTaskDtoToJSON)),
        'assign': WizardPlanAssignmentDtoToJSON(value['assign']),
    };
}

